import type { SyntheticEvent } from 'react';
import React, { useCallback } from 'react';

import { Modal, Button, Spin } from 'antd';

interface IProps {
  hasActive: boolean;
  closeModal?: (...args: any[]) => any;

  title?: string;
  subTitle?: string | JSX.Element;

  hasButtons?: boolean;
  hideButtonOk?: boolean;

  handleClickOk?: (...args: any[]) => any;
  textButtonOk?: string;
  textButtonCancel?: string;

  loading?: boolean;

  children: any;
  style?: any;
}

const MyModal: React.FC<IProps> = ({
  hasActive,
  closeModal,
  title,
  subTitle,
  children,
  hasButtons,
  hideButtonOk,
  handleClickOk,
  textButtonOk,
  textButtonCancel,
  loading
}) => {
  const onClose = useCallback(
    (ev: SyntheticEvent) => {
      if (loading) {
        return;
      }

      closeModal(ev);
    },
    [loading, closeModal]
  );

  if (!hasActive) {
    return null;
  }

  return (
    <Modal
      open
      onCancel={onClose as any}
      title={
        title ? (
          <div>
            <span>{title}</span>
            {subTitle && <p className='mt-1 text-sm text-gray-500'>{subTitle}</p>}
          </div>
        ) : undefined
      }
      footer={
        hasButtons ? (
          <div className='flex justify-end gap-2'>
            <Button onClick={closeModal as any} disabled={loading}>
              {textButtonCancel || 'Cancelar'}
            </Button>

            {!hideButtonOk && (
              <Button type='primary' onClick={handleClickOk as any} disabled={loading}>
                {textButtonOk || 'Confirmar'}
                {loading && (
                  <span className='relative top-0.5 ml-2.5 inline-block'>
                    <Spin size='small' />
                  </span>
                )}
              </Button>
            )}
          </div>
        ) : null
      }
    >
      {children}
    </Modal>
  );
};

export default MyModal;
